import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, MonitorSmartphoneIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const miniBadges = [{
  emoji: '📗',
  label: '6 Volumes'
}, {
  emoji: '🎁',
  label: '5 Pro Bonuses'
}, {
  emoji: '📄',
  label: '300+ Pages'
}, {
  emoji: '⏱',
  label: 'Minute-by-Minute Wedding Day Timeline'
}, {
  emoji: '🌍',
  label: 'Works in Any Country'
}];
const trustItems = [{
  Icon: LockIcon,
  label: 'Secure checkout'
}, {
  Icon: ZapIcon,
  label: 'Instant download'
}, {
  Icon: ShieldCheckIcon,
  label: '7-day guarantee'
}, {
  Icon: MonitorSmartphoneIcon,
  label: '100% digital (PDF)'
}];
export function Hero() {
  return <section className="relative w-full bg-ivory overflow-hidden" data-id="element-134" data-mp="sd4c94c3fcpj">
      <div className="mx-auto max-w-6xl px-5 pt-10 pb-16 sm:pt-16 sm:pb-24" data-id="element-135" data-mp="nbomx02vuk1c">
        <div className="flex justify-center" data-id="element-136" data-mp="3d2l95b1th306">
          <span className="inline-flex items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-[10px] sm:text-[11px] uppercase tracking-[0.24em] text-ink-soft" data-id="element-137" data-mp="3cz5uuafyvxzt">
            <span aria-hidden="true" className="text-gold-dark" data-id="element-138" data-mp="3j9ai9gc8yw6q">
              ◆
            </span>
            The Wedding Pro OS™ — The system luxury planners never share
          </span>
        </div>

        <h1 className="mt-8 text-center font-serif text-[2.1rem] leading-[1.12] sm:text-6xl sm:leading-[1.08] text-ink" data-id="element-139" data-mp="39a378zszjdms">
          Run every wedding like a{' '}
          <span className="italic text-gold-dark" data-id="element-140" data-mp="30hrjxmt646b1"> luxury planner.</span>
          <br className="hidden sm:block" data-id="element-141" data-mp="358hm6r6art1i" /> Even if it&rsquo;s your first.
        </h1>

        <div className="rule-gold mx-auto mt-8 w-40" aria-hidden="true" data-id="element-142" data-mp="2qjv80ssep7bv" />

        <p className="mx-auto mt-8 max-w-3xl text-center text-base sm:text-lg leading-relaxed text-ink-soft" data-id="element-143" data-mp="2qlof296xltke">
          The complete 6-volume operating system for wedding planners — 300+ pages of
          word-for-word scripts, budgets, timelines and vendor systems. From first inquiry
          to flawless wedding day to referrals on repeat.
        </p>

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-144" data-mp="s2b6puz5ad3k">
          {miniBadges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 rounded-full border border-ink/10 bg-white px-3.5 py-1.5 text-xs text-ink-soft" data-id="element-145" data-mp="n98djnya55nw">
              <span aria-hidden="true" data-id="element-146" data-mp="db2ede3uydmq">{badge.emoji}</span>
              {badge.label}
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-147" data-mp="1622j5ra0jlfg">
          <CtaButton data-id="element-148" data-mp="162cd1py6icqf">Get the Wedding Pro OS — Instant Access</CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-149" data-mp="111eql164ywj4">
          {trustItems.map(({
          Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-2" data-id="element-150" data-mp="3ltqeji9dp5w5">
              <Icon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-151" data-mp="3hqu1e72ly1zl" />
              {label}
            </li>)}
        </ul>

        <figure className="mt-14 sm:mt-16" data-id="element-152" data-mp="1xb5pse406rg4">
          <div className="mx-auto max-w-4xl border border-gold-soft bg-white p-3 shadow-card" data-id="element-153" data-mp="21amuv6fipmkr">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/f0f41107-8fcd-466d-9a4c-511f9272dc26.jpg" alt="The six printed volumes of The Wedding Pro OS laid out with a planner, tablet and gold pen" className="w-full object-cover" loading="eager" data-id="element-154" data-mp="26a98hgz9d4u3" />
          </div>
        </figure>
      </div>
    </section>;
}